import { SPlyr } from 'components/Lesson';
import React from 'react';
import 'plyr-react/dist/plyr.css';
import Plyr from 'plyr-react';
import { PLAYER_CONTROLS } from 'utils/common.util';
import { ConsultingType } from 'types/course.type';

const MoreData: React.FC<{ data: ConsultingType }> = ({ data }) => {
  return (
    <div className="w-[330px] mb-[80px] rounded-2xl gap-[48px] md:w-[640px] flex-col xl:flex-row m-auto xl:w-[1160px] flex">
      <div className="">
        <div className="text-indigo90 font-bold text-[24px] mb-[20px]">مشاوره آنلاین</div>

        <div className="p-2 flex-1 font-regular text-[16px] text-black60">
          {data.onlineCounselingDescription}
        </div>
        <div className="text-indigo90 mt-[48px] font-bold text-[24px] mb-[20px]">
          {' '}
          مشاوره آفلاین
        </div>

        <div className="p-2 flex-1 font-regular text-[16px] text-black60">
          {data.offlineCounselingDescription}
        </div>
      </div>
      <div className="flex flex-col self-center xl:flex-row  w-[300px] md:w-[360px] shrink-0">
        <SPlyr className="flex-1 rounded-3xl overflow-hidden">
          <Plyr
            source={{ type: 'video', sources: [{ src: data.intro }] }}
            options={{ controls: PLAYER_CONTROLS }}
          />
        </SPlyr>
      </div>
    </div>
  );
};

export default MoreData;
